export const getCollectionFeaturesTranslated = (t) => [
  {
    id: "audience-context",
    title: t("landing.collection.feature_title_01"),
    description: t("landing.collection.feature_description_01"),
    icon: "audience",
  },
  {
    id: "entry-point",
    title: t("landing.collection.feature_title_02"),
    description: t("landing.collection.feature_description_02"),
    icon: "link",
  },
];
